import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/measure_types',
    name: 'MeasureType',
    component: {
      name: 'AdminMeasureType',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'measure_type',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminMeasureTypeIndex',
        component: () => import('../views/MeasureTypeIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminMeasureTypeNew',
        component: () => import('../views/MeasureTypeInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminMeasureTypeIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminMeasureTypeShow',
        component: () => import('../views/MeasureTypeShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminMeasureTypeIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminMeasureTypeDetails',
            component: () => import('../views/MeasureTypeDetails.vue'),
            meta: {
              backRoute: { name: 'AdminMeasureTypeIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminMeasureTypeEdit',
            component: () => import('../views/MeasureTypeInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminMeasureTypeDetails' },
            },
          },
          {
            path: 'measures',
            name: 'Measure',
            component: {
              name: 'AdminMeasure',
              render(h) {
                return h('router-view');
              },
            },
            get redirect() {
              return this.children[0];
            },
            meta: {
              backRoute: { name: 'AdminMeasureTypeDetails' },
              resource: 'measure',
            },
            children: [
              {
                path: '',
                name: 'AdminMeasureIndex',
                component: () => import('../views/measure/MeasureTypeMeasures.vue'),
                meta: {
                  backRoute: { name: 'AdminMeasureTypeDetails' },
                },
              },
              {
                path: 'new',
                name: 'AdminMeasureNew',
                component: () => import('../views/measure/MeasureInput.vue'),
                meta: {
                  action: 'new',
                  backRoute: { name: 'AdminMeasureIndex' },
                },
              },
              {
                path: ':measureId(\\d+)',
                name: 'AdminMeasureShow',
                component: () => import('../views/measure/MeasureShow.vue'),
                meta: {
                  backRoute: {
                    name: 'AdminMeasureIndex',
                  },
                  tArgs: route => ({ name: route.params?.measureId }),
                },
                get redirect() {
                  return this.children[0];
                },
                children: [
                  {
                    path: '',
                    name: 'AdminMeasureDetails',
                    component: () => import('../views/measure/MeasureDetails.vue'),
                    meta: {
                      backRoute: { name: 'AdminMeasureIndex' },
                    },
                  },
                  {
                    path: 'edit',
                    name: 'AdminMeasureEdit',
                    component: () => import('../views/measure/MeasureInput.vue'),
                    meta: {
                      action: 'edit',
                      backRoute: { name: 'AdminMeasureDetails' },
                    },
                  },
                ]
              }
            ],
          },
        ],
      },
    ]
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));